// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { searchHistoryStyles, SearchHistoryStyles } from "@conklin/Overrides/Widgets/Header/SearchHistory";
import { color, xScreen } from "@conklin/XDL/Utilities";
import Clock from "@insite/mobius/Icons/Clock";
import { css } from "styled-components";

const searchHistoryStylesExtensions: SearchHistoryStyles = {
    headerText: {
        variant: "h6",
        css: css`
            text-align: left;
            margin-bottom: 8px;
        `,
    },
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 420px;
            padding: 12px;
            ${xScreen("lte", "md")} {
                width: 100%;
            }
        `,
    },
    itemWrapper: {
        css: css`
            display: flex;
            align-items: center;
            margin-bottom: 6px;
        `,
    },
    icon: {
        src: Clock,
        size: 12,
        color: "common.ui10",
        css: css`
            margin-right: 8px;
        `,
    },
    link: {
        typographyProps: {
            ellipsis: true,
            size: 12,
            lineHeight: "14px",
            css: css`
                width: 100%;
                text-align: left;
            `,
        },
        css: css`
            width: 100%;
            overflow: hidden;
        `,
    },
    focusedLink: {
        typographyProps: {
            ellipsis: true,
            size: 12,
            lineHeight: "14px",
            css: css`
                text-align: left;
                width: 100%;
            `,
        },
        css: css`
            width: 100%;
            overflow: hidden;
            background: ${color("common.ui3")};
        `,
    },
    clearLink: {
        typographyProps: {
            size: 12,
            lineHeight: "14px",
            css: css`
                width: 100%;
                text-align: right;
                margin-top: 12px;
            `,
        },
    },
};

searchHistoryStyles.headerText = searchHistoryStylesExtensions.headerText;
searchHistoryStyles.wrapper = searchHistoryStylesExtensions.wrapper;
searchHistoryStyles.itemWrapper = searchHistoryStylesExtensions.itemWrapper;
searchHistoryStyles.icon = searchHistoryStylesExtensions.icon;
searchHistoryStyles.link = searchHistoryStylesExtensions.link;
searchHistoryStyles.focusedLink = searchHistoryStylesExtensions.focusedLink;
searchHistoryStyles.clearLink = searchHistoryStylesExtensions.clearLink;
